import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import HamQuest from './api/HamQuestGiver';
import LoadingEllipsis from './forms/LoadingEllipsis';

const Error = styled.p`
    color: ${({ theme }) => theme.error};
`;

const Loader = ({ route, setData, children, ...props }) => {
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)

    useEffect(() => {
        HamQuest.get(route)
            .then(data => {
                setData(data)
                setLoading(false)
            })
            .catch(err => {
                setError(err.errorMessage || 'Something went wrong!')
                setLoading(false)
            })
    }, [])

    if (loading) {
        return <p>Loading<LoadingEllipsis /></p>
    }

    if (error) {
        return <Error>{error.message}</Error>
    }

    return (children);
}

export default Loader;
